import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { merge } from 'es-toolkit';
import {finalize, switchMap, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';


import {ContactsService} from '../contacts/contacts.service';
import {forkJoin} from 'rxjs';
import {BaseService} from '../../../../shared/src/lib/services/base.service';
import {ToastService} from '../../../../shared/src/lib/services/toast.service';
import {GenericModalComponent} from '../../../../shared/src/lib/modals/generic-modal/generic-modal.component';
import {
  AttachmentModalComponent
} from '../../../../shared/src/lib/attachments/attachment-modal/attachment-modal.component';

@Injectable({
  providedIn: 'root'
})
export class TierIIService extends BaseService {
  public item: any = {};
  public meta: any = {};
  relatedContactsService: BaseService;

  constructor(http: HttpClient, private contactsService: ContactsService, private modalService: NgbModal,
              private toastService: ToastService) {
    super(`${environment.baseUrl}/tierii/facilities`, http);
    this.relatedContactsService = new BaseService(`${environment.baseUrl}/tierii/contactrelationshiptypes`, http);
  }

  public loadData(searchObj) {
    return this.getList<any>(searchObj).pipe(tap(response => {
      if (response.results[0]) {
        merge(this.item, response.results[0]);
      } else {
        this.item = {};
      }
      merge(this.meta, response.meta);
      this.meta.display_fields = ['naicscode', 'dbnumber', 'phone', 'claims_confidential', 'latest_reporting_year'];
      this.meta.type = 'tierii/facilities';

      this.meta.urlPath = 'tierii';
      this.meta.subItems = ['certifications', 'contacts', 'materialsatsite', 'attachments'];
      this.meta.action_buttons = [
        {
          label: 'Upload New Tier II Submit',
          icon: 'fa-upload',
          func: item => {
            const confirm = this.modalService.open(GenericModalComponent)
            confirm.componentInstance.text = 'This will replace all existing Tier II data for this site.' +
              ' Please confirm you want to proceed.';
            confirm.result.then(() => {
              const modalInstance = this.modalService.open(AttachmentModalComponent);
              modalInstance.componentInstance.attachmentInfo = {
                type: 'tierii/facilityattachments',
                foreignKey: item.globalid
              };
              modalInstance.result.then(attachments => {
                if (attachments !== undefined) {
                  console.log(attachments);
                  const a = attachments[0];
                  this.toastService.warning('Processing Tier II Submit File')
                  this.customPOST(`${a.rel_globalid}/process_tierii_submit`, {file_id: a.globalid}).pipe(
                    // todo: figure out better way to reload just the tierii section
                    tap(() => location.reload())
                    // switchMap(() => this.reloadData({search: item.site})),
                    // finalize(() => this.toastService.success('Tier II Submit Processing Complete'))
                  ).subscribe()
                  // this.attachments = this.attachments.concat(attachments);
                }
              });
            })

          }
        },
      ]
      this.meta.fields.certifications.display_fields = ['reportingyear', 'datetime'];
      this.meta.fields.certifications.type = 'tierii/certifications';
      this.meta.fields.certifications.verbose_name = 'Certification';
      this.meta.fields.certifications.verbose_name_plural = 'Certifications';
      this.meta.fields.certifications.foreign_key_field = 'tieriifacility';

      this.meta.fields.contacts = {
        type: 'tierii/contacts',
        display_fields: ['relationship_type', 'contact_display_name', 'contact_title', 'contact_phone_number', 'contact_alternate_phone'],
        foreign_key_field: 'tieriifacility',
        fields: {
          contact_first_name: {
            get_choices: this.contactsService.meta.fields.contact_first_name.get_choices,
            select_choice: this.contactsService.select_choice,
            choices: null
          },
          contact_org_name: {
            get_choices: this.contactsService.meta.fields.contact_org_name.get_choices,
            select_choice: this.contactsService.select_choice,
            choices: null
          },
          relationship_type: {
            get_choices: (search) => {
              return new Promise(resolve => {
                this.relatedContactsService.getList<any>({search}).pipe(tap(r => {
                  const choices = r.results.map(item => {
                    return {display_name: item.relationship_type, value: item.relationship_type};
                  });
                  resolve(choices);
                })).subscribe();
              });
            },
            select_choice: (selected, item) => {
              item.relationship_type = selected.value;
            },
            choices: null
          }
        }
      };


      this.meta.fields.materialsatsite.display_fields = [
        'chemical', 'cascode', 'ehs', 'hazards', 'maxdailyamount', 'avgdailyamount', 'daysonsite',
        'containertype', 'pressure', 'temperature', 'storagelocation'
      ];
//                    this.meta.fields.materialsatsite.subItems = ['materialattachments']
//                    this.meta.fields.materialsatsite.materialattachments = {type: "tierii/materialattachments"};
      this.meta.fields.materialsatsite.type = 'tierii/materials';
      this.meta.fields.materialsatsite.verbose_name_plural = 'Materials at site';
      this.meta.fields.materialsatsite.verbose_name = 'Materials at site';
      this.meta.fields.materialsatsite.foreign_key_field = 'tieriifacility';

      this.meta.fields.attachments = {type: 'tierii/facilityattachments'};

    }));
  }

  private reloadData(searchObj) {
    return this.getList<any>(searchObj).pipe(tap(response => {
      if (response.results[0]) {
        merge(this.item, response.results[0]);
      }
    }));
  }
}
